import React from 'react'

const Setting = () => {
  return (
    <div>
      Settings
    </div>
  )
}

export default Setting
